import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`

  html {
    scroll-behavior: smooth; 
    scroll-padding-top: 30vh; 
  }

  body {
    margin: 0;
    min-height: 100vh; 
    background: #f3f5fb;
    color: #0b1221;
    font-family: Inter, system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif;
  }

  #root {
    min-height: 100vh; 
  }

`;
